// @ts-check
import QuickFillButton from './QuickFillButton';

export default QuickFillButton;
